export enum UserGender {
  Female = 1,
  Male,
}
